import { render, staticRenderFns } from "./estatisticas-tempo.vue?vue&type=template&id=62796d88&scoped=true"
import script from "./estatisticas-tempo.vue?vue&type=script&lang=js"
export * from "./estatisticas-tempo.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-tempo.vue?vue&type=style&index=0&id=62796d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62796d88",
  null
  
)

export default component.exports